import { useMutation } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { downloadFromApi } from 'src/common/utils/api/downloadFromApi';

type ExportParams = {
  includeInternal: boolean;
};

export function useBillingExport() {
  const {
    mutateAsync,
    isPending: isLoading,
    error,
  } = useMutation<void, Error, ExportParams>({
    mutationFn: ({ includeInternal }) =>
      downloadFromApi(`/admin/billing/export?include_internal=${includeInternal}`, 'billing.xlsx'),
    onError: () => {
      notifications.show({
        color: 'red',
        message: 'Could not download the billing spreadsheet',
      });
    },
  });

  return {
    downloadExport: (params: ExportParams) => mutateAsync(params).catch(() => undefined),
    isLoading,
    error,
  };
}
